import { Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import RadioGroup from '@mui/material/RadioGroup';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomFormControlLabel, CustomRadio, StyledRadioButton } from './style';

const RadioButtonGroup = ({
  name,
  label,
  options,
  onChange,
  defaultValue,
  hintText,
  horizontal = false
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const hasError = Boolean(errors?.[name]);

  return (
    <FormControl component="fieldset" error={hasError}>
      <StyledRadioButton component="legend">
        <div className="bulletShape"></div>
        {label}
      </StyledRadioButton>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue} // Set default checked value here
        render={({ field }) => (
          <RadioGroup
            {...field}
            row={horizontal} // Apply row layout only when horizontal prop is true
          >
            {options.map((option) =>
              horizontal ? (
                <Box key={option.value} sx={{ mr: 2 }}>
                  <CustomFormControlLabel
                    value={t(option.value)}
                    control={<CustomRadio onChange={onChange} />}
                    label={t(`${option.label}`)}
                  />
                </Box>
              ) : (
                <CustomFormControlLabel
                  key={option.value}
                  value={t(option.value)}
                  control={<CustomRadio onChange={onChange} />}
                  label={t(`${option.label}`)}
                />
              )
            )}
          </RadioGroup>
        )}
      />
      {hasError && (
        <FormHelperText className="errormsg" sx={{ fontSize: '14px' }}>
          {errors[name]?.message}
        </FormHelperText>
      )}
      {hintText && (
        <Typography
          variant="caption"
          color="textSecondary"
          align="left"
          style={{ marginTop: '5px' }}>
          {hintText}
        </Typography>
      )}
    </FormControl>
  );
};

export default RadioButtonGroup;
